/**
 * Legal & company public details.
 * IMPORTANT: replace pivaVat and address with the real legal entity details before public launch.
 */

export const LEGAL = {
  companyName: "Decision Sales OS",
  pivaVat: "TO_BE_FILLED_BEFORE_PUBLIC_LAUNCH",
  address: "TO_BE_FILLED_BEFORE_PUBLIC_LAUNCH",
  dpoEmail: "info@decisionsalesos.com",
  supportEmail: "info@decisionsalesos.com",
  legalEmail: "info@decisionsalesos.com",
} as const;
